import { render } from "./mizeview.vue?vue&type=template&id=36da511a&scoped=true"
import script from "./mizeview.vue?vue&type=script&lang=js"
export * from "./mizeview.vue?vue&type=script&lang=js"

import "./mizeview.vue?vue&type=style&index=0&id=36da511a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36da511a"]])

export default __exports__